import React from "react";
import { Toaster } from "@/components/ui/toaster";

interface IProps {
  children: React.ReactNode;
}

export const PageWrapper: React.FC<IProps> = ({ children = null }) => {
  return (
    <div className="h-full w-full overflow-y-auto">
      <Toaster />
      <>{children}</>
    </div>
  );
};
